import React from 'react'

import type { Layout } from '../../../../firebase/model/mix'
import type { DeepReadonly } from '../../../../firebase/typeUtils'
import { posToStyle } from '../../../../Stage/layouts'

import './LayoutPreview.scss'

interface LayoutPreviewProps {
  layout: DeepReadonly<Layout>
}
const LayoutPreview = ({ layout }: LayoutPreviewProps) => {
  return (
    <div className="mix-layout-preview">
      <div>
        {layout.feeds.map((p, idx) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={idx}
            style={posToStyle(p)}
          />
        ))}
      </div>
    </div>
  )
}

export { LayoutPreview }
